import React, {FC, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {schemaClaim} from '../../../../../util/validation'
import {TabCentralModel} from '../../../../../models'
import {useCentral} from '../../../../../hooks/useCentral'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {renderPanelContent} from '../components'
import Swal from 'sweetalert2'
import {ClaimModel} from '../../../model/claim.model'
import {createClaim, deleteClaim, updateClaim} from '../../../services/claim.service'
import {ShowSnackBar} from '../../../../../util/functions'
const getUTCDate = (value: any) => {
  return new Date(
    Date.UTC(
      value.getUTCFullYear(),
      value.getUTCMonth(),
      value.getUTCDate(),
      value.getUTCHours(),
      value.getUTCMinutes(),
      value.getUTCSeconds(),
    ),
  )
}

const ClaimPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)

  const methods = useForm<ClaimModel>({
    resolver: yupResolver(schemaClaim),
  })
  const {reset} = methods

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        setLoading(true)
        let id = currentTabItem.idToDelete
        try {
          const data = await deleteClaim(id)
          if (!data.data.error) {
            const obj: TabCentralModel = {
              ...currentTabItem,
              idToDelete: '',
              loadingTable: true,
            }
            changeCurrentTabItem(obj)
            ShowSnackBar('Se eliminó con éxito')
          } else {
            ShowSnackBar(data.data.message, 'error')
          }
          setLoading(false)
        } catch (error) {
          setLoading(false)
          //   getSnackBarNoExit('Error interno')
        }

        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const onSubmit = async (data: ClaimModel) => {
    setLoading(true)
    data.Campoadicionalnum1 = Number(data.Campoadicionalnum1)
    data.Campoadicionalnum2 = Number(data.Campoadicionalnum2)
    data.Campoadicionalnum3 = Number(data.Campoadicionalnum3)
    if (data.CampoadicionalFec1) {
      const fechaLocal = new Date(data.CampoadicionalFec1)
      const fechaUTC = getUTCDate(fechaLocal)
      data.CampoadicionalFec1 = fechaUTC.toISOString()
    }

    if (data.CampoadicionalFec2) {
      const fechaLocal2 = new Date(data.CampoadicionalFec2)
      const fechaUTC2 = getUTCDate(fechaLocal2)
      data.CampoadicionalFec2 = fechaUTC2.toISOString()
    }

    try {
      if (currentTabItem.idToEdit) {
        // data.Id = currentTabItem.idToEdit
        const response = await updateClaim(data)
        if (!response.data.error) {
          setLoading(false)
          ShowSnackBar('Se actualizó el registro correctamente')
          const obj: TabCentralModel = {
            ...currentTabItem,
            showPanel: false,
            idToEdit: '',
            loadingTable: true,
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          ShowSnackBar(response.data.messageSystem, 'error')
        }
      } else {
        const response = await createClaim(data)
        if (!response.data.error) {
          setLoading(false)
          reset()
          ShowSnackBar('Se creó con éxito')
          const obj: TabCentralModel = {
            ...currentTabItem,
            content: {
              ...currentTabItem.content,
              headerPanel: 'table-claim',
            },
          }
          changeCurrentTabItem(obj)
        } else {
          setLoading(false)
          ShowSnackBar(response.data.messageSystem, 'error')
        }
      }
    } catch (error) {
      //   setLoading(false)
      //   getSnackBarNoExit('Error interno')
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-claim'
          textComponentGo='form-claim'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default ClaimPageWrapper
